export default __webpack_public_path__ + "media/images/work_with_us/team-pic-4-e39837dc23fc54617d29a4485c6e2894.webp";